export type JsonPathSegment = string | number;
export type JsonPath = JsonPathSegment[];

const ROOT_KEY = 'config.json';

export function pathToKey(path: JsonPath): string {
	if (path.length === 0) {
		return ROOT_KEY;
	}

	return path.reduce<string>((acc, segment) => {
		if (typeof segment === 'number') {
			return `${acc}[${segment}]`;
		}

		return `${acc}.${segment}`;
	}, ROOT_KEY);
}
